<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === notificationAdminFilterKey.Type) {
      <mat-selection-list [formField]="formTree.type">
        @for (type of notificationTypeValues; track $index) {
          <mat-list-option [value]="type" (click)="$event.stopPropagation()">
            {{ type }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === notificationAdminFilterKey.Read) {
      <mat-selection-list [formField]="formTree.read">
        @for (read of readValues; track $index) {
          <mat-list-option [value]="read" (click)="$event.stopPropagation()">
            {{ read === 'true' ? 'Lu' : 'Non lu' }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
